// import { ENDPOINTS } from "../../apiConfig";
// import { showToast } from "../../../components";
// import axiosRequest from "../universal/axiosService";

// // export const fetchTimesheets = async ({
// //   limit,
// //   page,
// //   filters,
// //   sort,
// //   ret,
// //   ref,
// //   incl,
// // }) => {
// //   try {
// //     const token = localStorage.getItem("token");

// //     const [timesheetsResponse, totalCountResponse] = await Promise.all([
// //       axios.get(ENDPOINTS.TIMESHEETS.GET_ALL, {
// //         params: {
// //           coll: "Timesheet",
// //           lim: limit,
// //           pg: page,
// //           fil: JSON.stringify(filters),
// //           cache: false,
// //           sort: JSON.stringify(sort),
// //           ret,
// //           ref,
// //           incl,
// //         },
// //         headers: {
// //           Authorization: `Bearer ${token}`,
// //           "Content-Type": "application/json",
// //         },
// //         withCredentials: true,
// //       }),
// //       axios.get(ENDPOINTS.TIMESHEETS.GET_TOTAL_COUNT, {
// //         params: {
// //           coll: "Timesheet",
// //           fil: JSON.stringify(filters),
// //         },
// //         headers: {
// //           Authorization: `Bearer ${token}`,
// //           "Content-Type": "application/json",
// //         },
// //         withCredentials: true,
// //       }),
// //     ]);

// //     return {
// //       data: timesheetsResponse.data,
// //       totalCount: totalCountResponse.data,
// //     };
// //   } catch (error) {
// //     console.error("API Error:", error.response || error);
// //     throw error;
// //   }
// // };
// export const fetchTimesheets = async ({
//   limit,
//   page,
//   filters,
//   sort,
//   ret,
//   ref,
//   incl,
// }) => {
//   const [data, totalCount] = await Promise.all([
//     axiosRequest({
//       method: "GET",
//       url: ENDPOINTS.TIMESHEETS.GET_ALL,
//       params: {
//         coll: "Timesheet",
//         lim: limit,
//         pg: page,
//         fil: JSON.stringify(filters),
//         cache: false,
//         sort: JSON.stringify(sort),
//         ret,
//         ref,
//         incl,
//       },
//     }),
//     axiosRequest({
//       method: "GET",
//       url: ENDPOINTS.TIMESHEETS.GET_TOTAL_COUNT,
//       params: {
//         coll: "Timesheet",
//         fil: JSON.stringify(filters),
//       },
//     }),
//   ]);

//   return { data: data.data, totalCount: totalCount.data };
// };

// // export const fetchOneTimesheet = async ({
// //   timesheetUiid,
// //   filters,
// //   retrieve,
// //   ref,
// //   incl,
// // }) => {
// //   try {
// //     const token = localStorage.getItem("token");

// //     const response = await axios.get(ENDPOINTS.TIMESHEETS.GET_BY_UIID, {
// //       params: {
// //         coll: "Timesheet",
// //         ret: retrieve,
// //         ref,
// //         fil: JSON.stringify(filters),
// //         incl,
// //       },
// //       headers: {
// //         Authorization: `Bearer ${token}`,
// //         "Content-Type": "application/json",
// //       },
// //       withCredentials: true,
// //     });
// //     // if (response.status === 200) {
// //     //   showToast("Timesheet found", "success", 3000);
// //     // }
// //     return response.data;
// //   } catch (error) {
// //     console.error("API Error:", error.response);
// //     // if (error.response?.status === 404) {
// //     //   showToast("Timesheet not found", "error", 3000);
// //     // }
// //     throw error;
// //   }
// // };

// export const fetchOneTimesheet = async ({
//   timesheetUiid,
//   filters,
//   retrieve,
//   ref,
//   incl,
// }) => {
//   return await axiosRequest({
//     method: "GET",
//     url: ENDPOINTS.TIMESHEETS.GET_BY_UIID,
//     params: {
//       coll: "Timesheet",
//       ret: retrieve,
//       ref,
//       fil: JSON.stringify(filters),
//       incl,
//     },
//   });
// };

// // export const addTimesheet = async (timesheetData) => {
// //   try {
// //     const token = localStorage.getItem("token");
// //     console.log("timesheetData in add timesheet api", timesheetData);
// //     const response = await axios.post(
// //       ENDPOINTS.TIMESHEETS.ADD_NEW,
// //       {
// //         coll: "Timesheet",
// //         payload: timesheetData,
// //       },
// //       {
// //         headers: {
// //           Authorization: `Bearer ${token}`,
// //           "Content-Type": "application/json",
// //         },
// //         withCredentials: true,
// //       }
// //     );

// //     return {
// //       success: true,
// //       data: response.data,
// //     };
// //   } catch (error) {
// //     console.error("API Error:", error.response || error);
// //     return {
// //       success: false,
// //       error: error?.response?.data?.error || "Failed to add new timesheet",
// //     };
// //   }
// // };

// export const addTimesheet = async (timesheetData) => {
//   console.log("timesheet data in add timesheet api", timesheetData);
//   return await axiosRequest({
//     method: "POST",
//     url: ENDPOINTS.TIMESHEETS.ADD_NEW,
//     data: {
//       coll: "Timesheet",
//       payload: timesheetData,
//     },
//   });
// };

// // export const updateTimesheet = async ({
// //   coll,
// //   uiid,
// //   payload,
// //   patchId,
// //   tPath,
// // }) => {
// //   try {
// //     const token = localStorage.getItem("token");

// //     const params = new URLSearchParams({
// //       coll,
// //       uiid,
// //       ...(patchId && { patchId }),
// //       ...(tPath && { tPath }),
// //     });

// //     const response = await axios.patch(
// //       `${ENDPOINTS.TIMESHEETS.UPDATE}?${params.toString()}`,
// //       { payload },
// //       {
// //         headers: {
// //           Authorization: `Bearer ${token}`,
// //           "Content-Type": "application/json",
// //         },
// //         withCredentials: true,
// //       }
// //     );

// //     return {
// //       success: true,
// //       data: response.data,
// //     };
// //   } catch (error) {
// //     console.error("API Error:", error.response || error);
// //     return {
// //       success: false,
// //       error: error?.response?.data?.error || "Failed to update timesheet",
// //     };
// //   }
// // };

// export const updateTimesheet = async ({
//   coll,
//   uiid,
//   payload,
//   patchId,
//   tPath,
// }) => {
//   return await axiosRequest({
//     method: "PATCH",
//     url: ENDPOINTS.TIMESHEETS.UPDATE,
//     params: {
//       coll,
//       uiid,
//       ...(patchId && { patchId }),
//       ...(tPath && { tPath }),
//     },
//     data: {
//       payload,
//     },
//   });
// };
// export const fetchTimesheetsPlacements=async({filters,sort,limit,page,ret,ref,incl})=>{
//   return await axiosRequest({
//       method: "GET",
//       url: ENDPOINTS.TIMESHEETS.GET_ALL,
//       params: {
//         coll: "Timesheet",
//         lim: limit,
//         pg: page,
//         fil: JSON.stringify(filters),
//         cache: false,
//         // sort: JSON.stringify(sort),
//         ret,
//         ref,
//         incl,
//       },
//     });
// };





import { ENDPOINTS } from "../../apiConfig";
import { showToast } from "../../../components";
import axiosRequest from "../universal/axiosService";

// export const fetchTimesheets = async ({
//   limit,
//   page,
//   filters,
//   sort,
//   ret,
//   ref,
//   incl,
// }) => {
//   try {
//     const token = localStorage.getItem("token");

//     const [timesheetsResponse, totalCountResponse] = await Promise.all([
//       axios.get(ENDPOINTS.TIMESHEETS.GET_ALL, {
//         params: {
//           coll: "Timesheet",
//           lim: limit,
//           pg: page,
//           fil: JSON.stringify(filters),
//           cache: false,
//           sort: JSON.stringify(sort),
//           ret,
//           ref,
//           incl,
//         },
//         headers: {
//           Authorization: Bearer ${token},
//           "Content-Type": "application/json",
//         },
//         withCredentials: true,
//       }),
//       axios.get(ENDPOINTS.TIMESHEETS.GET_TOTAL_COUNT, {
//         params: {
//           coll: "Timesheet",
//           fil: JSON.stringify(filters),
//         },
//         headers: {
//           Authorization: Bearer ${token},
//           "Content-Type": "application/json",
//         },
//         withCredentials: true,
//       }),
//     ]);

//     return {
//       data: timesheetsResponse.data,
//       totalCount: totalCountResponse.data,
//     };
//   } catch (error) {
//     console.error("API Error:", error.response || error);
//     throw error;
//   }
// };
export const fetchTimesheets = async ({
  limit,
  page,
  filters,
  sort,
  ret,
  ref,
  incl,
  useAggregate = false,
}) => {
  const requests = [
    axiosRequest({
      method: "GET",
      url: ENDPOINTS.TIMESHEETS.GET_ALL,
      params: {
        coll: "Timesheet",
        lim: limit,
        pg: page,
        fil: JSON.stringify(filters),
        cache: false,
        sort: JSON.stringify(sort),
        ret,
        ref,
        incl,
        ...(useAggregate && { useAggregate }),
      },
    }),
  ];
  if (!useAggregate) {
    requests.push(
      axiosRequest({
        method: "GET",
        url: ENDPOINTS.TIMESHEETS.GET_TOTAL_COUNT,
        params: {
          coll: "Timesheet",
          fil: JSON.stringify(filters),
        },
      })
    );
  }
  const results = await Promise.all(requests);
  const dataRes = results[0];
  if (useAggregate) {
      const groupedData = dataRes?.data?.data?.[0];
      return { 
          data: { data: groupedData?.data || [] }, 
          totalCount: { data: groupedData?.total?.[0]?.count || 0 }
      };
  } else {
      const totalCountRes = results[1];
      return { data: dataRes.data, totalCount: totalCountRes.data };
  }
};

// export const fetchOneTimesheet = async ({
//   timesheetUiid,
//   filters,
//   retrieve,
//   ref,
//   incl,
// }) => {
//   try {
//     const token = localStorage.getItem("token");

//     const response = await axios.get(ENDPOINTS.TIMESHEETS.GET_BY_UIID, {
//       params: {
//         coll: "Timesheet",
//         ret: retrieve,
//         ref,
//         fil: JSON.stringify(filters),
//         incl,
//       },
//       headers: {
//         Authorization: Bearer ${token},
//         "Content-Type": "application/json",
//       },
//       withCredentials: true,
//     });
//     // if (response.status === 200) {
//     //   showToast("Timesheet found", "success", 3000);
//     // }
//     return response.data;
//   } catch (error) {
//     console.error("API Error:", error.response);
//     // if (error.response?.status === 404) {
//     //   showToast("Timesheet not found", "error", 3000);
//     // }
//     throw error;
//   }
// };

export const fetchOneTimesheet = async ({
  timesheetUiid,
  filters,
  retrieve,
  ref,
  incl,
}) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.TIMESHEETS.GET_BY_UIID,
    params: {
      coll: "Timesheet",
      ret: retrieve,
      ref,
      fil: JSON.stringify(filters),
      incl,
    },
  });
};

// export const addTimesheet = async (timesheetData) => {
//   try {
//     const token = localStorage.getItem("token");
//     console.log("timesheetData in add timesheet api", timesheetData);
//     const response = await axios.post(
//       ENDPOINTS.TIMESHEETS.ADD_NEW,
//       {
//         coll: "Timesheet",
//         payload: timesheetData,
//       },
//       {
//         headers: {
//           Authorization: Bearer ${token},
//           "Content-Type": "application/json",
//         },
//         withCredentials: true,
//       }
//     );

//     return {
//       success: true,
//       data: response.data,
//     };
//   } catch (error) {
//     console.error("API Error:", error.response || error);
//     return {
//       success: false,
//       error: error?.response?.data?.error || "Failed to add new timesheet",
//     };
//   }
// };

export const addTimesheet = async (timesheetData) => {
  console.log("timesheet data in add timesheet api", timesheetData);
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.TIMESHEETS.ADD_NEW,
    data: {
      coll: "Timesheet",
      payload: timesheetData,
    },
  });
};

// export const updateTimesheet = async ({
//   coll,
//   uiid,
//   payload,
//   patchId,
//   tPath,
// }) => {
//   try {
//     const token = localStorage.getItem("token");

//     const params = new URLSearchParams({
//       coll,
//       uiid,
//       ...(patchId && { patchId }),
//       ...(tPath && { tPath }),
//     });

//     const response = await axios.patch(
//       ${ENDPOINTS.TIMESHEETS.UPDATE}?${params.toString()},
//       { payload },
//       {
//         headers: {
//           Authorization: Bearer ${token},
//           "Content-Type": "application/json",
//         },
//         withCredentials: true,
//       }
//     );

//     return {
//       success: true,
//       data: response.data,
//     };
//   } catch (error) {
//     console.error("API Error:", error.response || error);
//     return {
//       success: false,
//       error: error?.response?.data?.error || "Failed to update timesheet",
//     };
//   }
// };

export const updateTimesheet = async ({
  coll,
  uiid,
  payload,
  patchId,
  tPath,
  preActions=[]
}) => {
  return await axiosRequest({
    method: "PATCH",
    url: ENDPOINTS.TIMESHEETS.UPDATE,
    params: {
      coll,
      uiid,
      ...(patchId && { patchId }),
      ...(tPath && { tPath }),
    },
    data: {
      ...(preActions.length && { preActions }),
      payload,
    },
  });
};
export const fetchTimesheetsPlacements = async ({
  filters,
  sort,
  limit,
  page,
  ret,
  ref,
  incl,
  useAggregate=false
}) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.TIMESHEETS.GET_ALL,
    params: {
      coll: "Timesheet",
      lim: limit,
      pg: page,
      fil: JSON.stringify(filters),
      cache: false,
      sort: JSON.stringify(sort),
      ret,
      ref,
      incl,
      ...(useAggregate && { useAggregate:true })
    },
  });
};
